import { type ReactNode, useId, useState } from "react";

import {
  Box,
  Button,
  ChevronDownIcon,
  ChevronUpIcon,
  Column,
} from "@hightouch/htui";

import { BLOCK_SPACING } from "src/components/llm/markdown/constants";

type Props = {
  defaultIsExpanded: boolean;
  /** Names the toggle ("Show SQL") so several blocks on one page are distinguishable. */
  languageLabel?: string;
  children: ReactNode;
};

/** Content behind a "Show code" toggle, for readers who only need the prose around it. */
export const CodeDisclosure = ({
  defaultIsExpanded,
  languageLabel = "code",
  children,
}: Props) => {
  const id = useId();
  const [isExpanded, setIsExpanded] = useState(defaultIsExpanded);

  return (
    <Column align="start" gap={2} mb={BLOCK_SPACING}>
      <Button
        size="sm"
        variant="tertiary"
        directionIcon={isExpanded ? ChevronUpIcon : ChevronDownIcon}
        aria-expanded={isExpanded}
        aria-controls={id}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? `Hide ${languageLabel}` : `Show ${languageLabel}`}
      </Button>
      <Box id={id} width="100%" hidden={!isExpanded}>
        {isExpanded && children}
      </Box>
    </Column>
  );
};
